import { Injectable } from '@angular/core';
import { CustomComponent } from '../../models/CustomComponent.model';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class ComponentRegistryService {

  private componentRegistry = new Map<string, CustomComponent>();
  //private customComponentRegistry = new Map<string, CustomComponent>();

  // Method to register a component class
  registerComponent(componentName: string, component: CustomComponent): void {
    if (!this.componentRegistry.has(componentName)) {
      //this.addInputsToComponent(component);
      this.componentRegistry.set(componentName, component);
      if (environment.debug) {
      }
    } else {
      if (environment.debug) {
      }
    }
  }

  private addInputsToComponent(component: CustomComponent): void {
    if (component.component && 'inputs' in component.component) {
      component.inputs = (component.component as any).inputs;
    }
  }

  // Method to retrieve a component class by its selector
  /*getComponentByUUID(componentUUID: string): CustomComponent | null {
    if (this.componentRegistry.has(componentUUID)) {
      const component = this.componentRegistry.get(componentUUID) || null;
      return component;
    } else {
      console.error(`Component not found for componentUUID: ${componentUUID}`);
      return null;
    }
  }*/

  getComponentByName(componentName: string): CustomComponent | null {
    return this.componentRegistry.get(componentName) || null;
  }

  getComponentRegistry(): Map<string, CustomComponent> {
    return this.componentRegistry;
  }
}
